export { default } from "./Avatar";
export { default as calculateAvatarColours } from "./helpers";
